import * as React from 'react'

import { observer } from 'mobx-react'

import {
  IConditionalField,
  IPermitTypeField,
  PermitFieldType,
} from '~/client/graph/types.generated'
import { restrictedTablePermitFieldTypes } from '~/client/src/shared/constants/PermitFieldTypeConstants'
import {
  MAX_PERMIT_TABLE_COLUMNS,
  PERMIT_TABLE_FIELDS_KEY,
} from '~/client/src/shared/constants/permitTypeFieldsConstants'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import SectionFieldList from './SectionFieldList'

interface IProps {
  field: IPermitTypeField
  allConditionalFields: IConditionalField[]

  addNewTableField(
    fieldId: string,
    key: string,
    index: number,
    fieldType: PermitFieldType,
  ): void
  updateTableField(
    fields: IPermitTypeField[],
    index: number,
    field: IPermitTypeField,
  ): void
  removeTableField(
    fieldId: string,
    key: string,
    conditionalFieldId: string,
  ): void
  reorderTableField(
    fields: IPermitTypeField[],
    fromIndex: number,
    toIndex: number,
  ): void
}

function TableFieldsConfigurator({
  field,
  allConditionalFields,
  addNewTableField,
  updateTableField,
  removeTableField,
  reorderTableField,
}: IProps): JSX.Element {
  const tableRule = allConditionalFields?.find(
    cf => cf.fieldId === field.id && cf.key === PERMIT_TABLE_FIELDS_KEY,
  )
  const columns = tableRule?.values || []

  return (
    <SectionFieldList
      title={Localization.translator.xTableColumns(columns.length)}
      emptyLabel={Localization.translator.tableColumns}
      addButtonLabel={Localization.translator.addTableColumn}
      fields={columns}
      restrictedFieldTypes={restrictedTablePermitFieldTypes}
      maxFields={MAX_PERMIT_TABLE_COLUMNS}
      onAddField={(index, fieldType) =>
        addNewTableField(field.id, PERMIT_TABLE_FIELDS_KEY, index, fieldType)
      }
      onUpdateField={(index, updated) =>
        updateTableField(columns, index, updated)
      }
      onRemoveField={removed =>
        removeTableField(field.id, PERMIT_TABLE_FIELDS_KEY, removed.id)
      }
      onReorderField={(fromIndex, toIndex) =>
        reorderTableField(columns, fromIndex, toIndex)
      }
    />
  )
}

export default observer(TableFieldsConfigurator)
